export default __webpack_public_path__ + "static/media/bigQueryIcon.01d0afdc.svg";